import "./notice.css";

function Notice() {
  return <></>;
}

export { Notice };
